export const IMPERIC_KOEFS = {
  volume: 33.814,
  weight: 2.20462,
  distance: 0.393701,
};

export const measureSystemLS = "APP_MEASURE_SYSTEM";
